import { render, staticRenderFns } from "./GroupsSearch.vue?vue&type=template&id=a962746c&scoped=true&"
import script from "./GroupsSearch.vue?vue&type=script&lang=js&"
export * from "./GroupsSearch.vue?vue&type=script&lang=js&"
import style0 from "./GroupsSearch.vue?vue&type=style&index=0&id=a962746c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a962746c",
  null
  
)

export default component.exports